import { render, staticRenderFns } from "./TeamEdit.vue?vue&type=template&id=280aa6d1&scoped=true&lang=pug&"
import script from "./TeamEdit.vue?vue&type=script&lang=js&"
export * from "./TeamEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeamEdit.vue?vue&type=style&index=0&id=280aa6d1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280aa6d1",
  null
  
)

export default component.exports